export const PUB_SUB_CHANNEL_APP = 'app';
export const PUB_SUB_CHANNEL_MODAL = 'modal';
export const PUB_SUB_CHANNEL_MEMBER_DRAFTS = 'member-drafts';
export const PUB_SUB_CHANNEL_MEMBER_LIKES = 'member-likes';
export const PUB_SUB_CHANNEL_MEMBER_POSTS = 'member-posts';
export const PUB_SUB_CHANNEL_MEMBER_COMMENTS = 'member-comments';
//# sourceMappingURL=pub-sub-channels.js.map